import useGtmSender from '../../../hooks/useGtmSender';

const LogoComponent = ({
    canvasStatus,
    setCanvasStatus,
    hallwayToLoby,
    setHallwayToLoby
}: any) => {
    const gtmSender = useGtmSender({} as any);
    // console.log("gtmSender", gtmSender);
    return (
        <img
            className="fixedButtonGroup-logo"
            src={'/leading/leadingPageAssets/indexPage/logo.png'}
            alt="logo"
            onClick={() => {
                // 移除點擊功能
                // if (hallwayToLoby) {
                //     hallwayToLoby();
                //     gtmSender({
                //         event: "新版-首頁_左上Logo"
                //     });
                //     setTimeout(() => {
                //         window.location.reload();
                //     }, 1000); //1秒種的動畫時間
                // }
                // //執行完再清空
                // setHallwayToLoby(null);
            }}
        />
    );
};

export default LogoComponent;
